export enum MustacheTagTypes {
  text = 1,
  boolean = 2,
  array = 3,
  implicitArray = 4,
  empty = 5
}